import { getStoredOverrides } from "../../DeveloperWorkbench/DeveloperWorkbench.utils";

export const getResolvedMfeProps = (route: any) => {
  const overrides = getStoredOverrides();
  const override = overrides[route.key];

  if (route.key === "react-dashboard-mfe") {
    if (override) {
      return {
        key: route.key,
        mfeType: "federated" as const,
        scope: "remote_app",
        module: "./Dashboard",
        scriptUrl: override.scriptUrl,
        cssUrl: override.cssUrl !== undefined ? override.cssUrl : route.cssUrl,
        mfeProps: {},
      };
    } else {
      return {
        key: route.key,
        mfeType: "custom-element" as const,
        elementName: "div",
        mfeProps: {},
        loadingFallback: (
          <div className="border-2 border-dashed border-purple-500/50 p-6 rounded-2xl bg-purple-500/5">
            <h4 className="text-purple-400 font-semibold mb-2 flex items-center gap-2">
              <i className="fa-brands fa-react"></i>
              React Federated MFE
            </h4>
            <p className="text-slate-300 text-sm leading-relaxed">
              Federated components require container assembly. Under production
              building, this maps to the `@originjs/vite-plugin-federation`
              import hook.
            </p>
            <div className="mt-3 p-2.5 bg-white/3 rounded-lg text-xs font-mono text-slate-400">
              remoteEntry: http://localhost:5002/assets/remoteEntry.js
            </div>
          </div>
        ),
      };
    }
  }

  if (override) {
    return {
      key: route.key,
      mfeType: route.mfeType,
      elementName: route.elementName,
      bootstrapFnName: route.bootstrapFnName,
      unmountFnName: route.unmountFnName,
      scope: route.scope,
      module: route.module,
      scriptUrl: override.scriptUrl || route.scriptUrl,
      cssUrl: override.cssUrl !== undefined ? override.cssUrl : route.cssUrl,
      mfeProps: route.mfeProps || {},
    };
  }

  return route;
};
